var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-purple-ap-100 font-light"},[_vm._v(" "+_vm._s(parseInt(_vm.fullHours) > 0 ? _vm.fullHours : "No Childcare Experience")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }